import React, { FC } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Layout from 'components/Layout';
import ApplicationDetails from 'components/Application/ApplicationDetails';

const ApplicationPage: FC = () => {
    const { t } = useTranslation();
    const { id } = useParams<Record<string, string>>();

    return (
        <Layout pageTitle={t('page.application-details.meta-title')}>
            <ApplicationDetails id={id} />
        </Layout>
    );
};

export default ApplicationPage;
